/* Supply6 Salts landing page. No dependencies. */
(function () {
  'use strict';

  function money(paise) {
    var n = Math.round(paise) / 100;
    return '₹ ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function moneyShort(paise) {
    var n = Math.round(paise / 100);
    return '₹ ' + n.toLocaleString('en-IN');
  }
  function cartAddUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
  }

  /* ---------------- generic horizontal carousel ---------------- */
  function carousel(root) {
    var track = root.querySelector('[data-slp-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slp-slide]'));
    var prev = root.querySelector('[data-slp-prev]');
    var next = root.querySelector('[data-slp-next]');
    var counter = root.querySelector('[data-slp-counter]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-slp-goto]'));
    var api = {};

    function index() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function paint() {
      var i = index();
      if (counter) counter.textContent = (i + 1) + '/' + slides.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (prev) prev.classList.toggle('is-disabled', i === 0);
      if (next) next.classList.toggle('is-disabled', i === slides.length - 1);
    }
    api.go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { api.go(index() - 1); });
    if (next) next.addEventListener('click', function () { api.go(index() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { api.go(parseInt(t.getAttribute('data-slp-goto'), 10) || 0); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
    }, { passive: true });
    paint();
    return api;
  }

  /* ---------------- hero / buy box ---------------- */
  function hero(root) {
    var dataEl = root.querySelector('[data-slp-products]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!products.length) return;

    var suffix = root.getAttribute('data-sachet-label') || 'Sachets';
    var defaultSize = root.getAttribute('data-default-size') || '';
    var sizesEl = root.querySelector('[data-slp-sizes]');
    var priceNow = root.querySelector('[data-slp-price-now]');
    var priceWas = root.querySelector('[data-slp-price-was]');
    var priceSave = root.querySelector('[data-slp-price-save]');
    var priceServing = root.querySelector('[data-slp-price-serving]');
    var qtyInput = root.querySelector('[data-slp-qty-input]');
    var errorEl = root.querySelector('[data-slp-error]');
    var addBtns = Array.prototype.slice.call(root.querySelectorAll('[data-slp-add]'));
    var stickyTitle = root.querySelector('[data-slp-sticky-title]');
    var stickyPrice = root.querySelector('[data-slp-sticky-price]');
    var stickyCompare = root.querySelector('[data-slp-sticky-compare-price]');
    var stickySave = root.querySelector('[data-slp-sticky-save]');

    var galleries = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-slp-gallery]'), function (g) {
      galleries[g.getAttribute('data-slp-gallery')] = { el: g, api: null };
    });

    var state = { product: products[0], variant: null, qty: 1 };

    /* remember the size across flavour switches by variant title (18/36/54) */
    function pickVariant(product, wantedTitle) {
      var v = null;
      if (wantedTitle) {
        v = product.variants.filter(function (x) { return x.title === wantedTitle && x.available; })[0] || null;
      }
      if (!v) v = product.variants.filter(function (x) { return x.available; }).slice(-1)[0] || product.variants[product.variants.length - 1];
      return v;
    }

    function renderSizes() {
      if (!sizesEl) return;
      sizesEl.innerHTML = '';
      state.product.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'slp-size' + (v.id === state.variant.id ? ' is-active' : '') + (v.available ? '' : ' is-soldout');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', v.id === state.variant.id ? 'true' : 'false');
        b.setAttribute('data-variant-id', v.id);
        b.innerHTML = '<span class="slp-size__radio" aria-hidden="true"></span><span class="slp-size__label">' + v.title + ' ' + suffix + (v.available ? '' : ' <em>(sold out)</em>') + '</span>';
        b.addEventListener('click', function () {
          state.variant = v;
          renderSizes();
          renderPrice();
        });
        sizesEl.appendChild(b);
      });
    }

    function renderPrice() {
      var v = state.variant;
      if (!v) return;
      if (priceNow) priceNow.textContent = money(v.price);
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) { priceWas.textContent = money(v.compare_at_price); priceWas.hidden = !hasCompare; }
      if (priceSave) { priceSave.textContent = 'Save ' + moneyShort(v.compare_at_price - v.price); priceSave.hidden = !hasCompare; }
      var count = parseInt(v.title, 10);
      if (priceServing) {
        if (count > 0) {
          priceServing.textContent = '₹' + Math.round(v.price / 100 / count) + ' / serving';
          priceServing.hidden = false;
        } else {
          priceServing.hidden = true;
        }
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price) + (hasCompare ? ' ' : '');
      if (stickyCompare) {
        stickyCompare.textContent = money(v.compare_at_price);
        stickyCompare.hidden = !hasCompare;
      }
      if (stickySave) {
        stickySave.textContent = '(SAVE ' + moneyShort(v.compare_at_price - v.price) + ')';
        stickySave.hidden = !hasCompare;
      }
      if (stickyTitle) stickyTitle.textContent = state.product.label + ' · ' + v.title + ' ' + suffix;
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-slp-add-label]');
        if (l) {
          if (!l.dataset.orig) l.dataset.orig = l.textContent;
          l.textContent = v.available ? l.dataset.orig : 'Sold out';
        }
      });
    }

    function showLabel(id) {
      var labels = Array.prototype.slice.call(root.querySelectorAll('[data-slp-label]'));
      if (!labels.length) return;
      var match = labels.filter(function (l) { return String(l.getAttribute('data-slp-label')) === String(id); })[0];
      labels.forEach(function (l) {
        var isDefault = l.getAttribute('data-slp-label') === 'default';
        l.hidden = match ? l !== match : !isDefault;
      });
    }

    function showGallery(id) {
      Object.keys(galleries).forEach(function (k) {
        var g = galleries[k];
        var on = String(k) === String(id);
        g.el.hidden = !on;
        if (on && !g.api) g.api = carousel(g.el);
        if (on && g.api) g.api.go(0);
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-slp-flavour]'), function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-slp-flavour');
        var p = products.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!p) return;
        Array.prototype.forEach.call(root.querySelectorAll('[data-slp-flavour]'), function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        state.product = p;
        state.variant = pickVariant(p, state.variant && state.variant.title);
        renderSizes();
        renderPrice();
        showGallery(p.id);
        showLabel(p.id);
      });
    });

    /* quantity */
    function setQty(n) {
      n = Math.max(1, Math.min(20, parseInt(n, 10) || 1));
      state.qty = n;
      if (qtyInput) qtyInput.value = n;
    }
    var minus = root.querySelector('[data-slp-qty-minus]');
    var plus = root.querySelector('[data-slp-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(state.qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(state.qty + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    /* add to cart */
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!state.variant || !state.variant.available) return;
        showError('');
        addBtns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.qty }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var drawer = document.getElementById('mini-cart');
            if (drawer && 'open' in drawer) { try { drawer.open = true; } catch (e) {} }
          })
          .catch(function (e) { showError(e.message); })
          .then(function () {
            addBtns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
          });
      });
    });

    /* tabs */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-slp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-slp-panel]'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-slp-tab');
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-slp-panel') !== key; });
      });
    });

    /* sticky bar: show once the in-page ATC has scrolled out of view */
    var sticky = root.querySelector('[data-slp-sticky]');
    var mainAtc = root.querySelector('.slp-buy');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        sticky.hidden = !show;
        document.body.classList.toggle('slp-sticky-active', show);
      }, { threshold: 0 });
      io.observe(mainAtc);
    }

    /* init */
    state.variant = pickVariant(state.product, defaultSize);
    renderSizes();
    renderPrice();
    showGallery(state.product.id);
    showLabel(state.product.id);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-slp-hero]'), function (r) {
      if (r.dataset.slpReady) return;
      r.dataset.slpReady = '1';
      hero(r);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-slp-carousel]'), function (r) {
      if (r.dataset.slpReady) return;
      r.dataset.slpReady = '1';
      carousel(r);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();



/* ---------------- gallery zoom popup ---------------- */
(function attachZoomHandlers() {
  if (!window.jQuery) {
    return setTimeout(attachZoomHandlers, 20);
  }
  var $ = window.jQuery;

  $(document).on('click', '.slp-gallery-zoom-btn', function () {
    var $gallery = $(this).closest('.slp-gallery');
    var $popup = $gallery.find('.slp-gallery-zoom-popup-wrap');
    var $media = $gallery.find('.slp-g-z-p-m-media');

    $popup.addClass('active').attr('open', 'true');

    if (!$media.length) return;

    function initSlick() {
      if ($media.hasClass('slick-initialized')) {
        // Popup was hidden since last open - slick's cached widths
        // are stale, recompute now that it's visible again.
        $media.slick('setPosition');
      } else {
        $media.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          adaptiveHeight: true,
          infinite: true,
          prevArrow: '<button type="button" class="slp-zoom-arrow slp-zoom-arrow--prev" aria-label="Previous"><svg width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10 2L2 10l8 8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button type="button" class="slp-zoom-arrow slp-zoom-arrow--next" aria-label="Next"><svg width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M2 2l8 8-8 8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 999,
              settings: {
                dots: true
              }
            }
          ]
        });

        // Zoom slide changed -> click the matching main-gallery thumb
        // so carousel() (defined above in this file) scrolls to match.
        $media.on('afterChange', function (e, slick, currentSlide) {
          $gallery.find('[data-slp-goto="' + currentSlide + '"]').trigger('click');
        });
      }

      // Open on whatever slide the main gallery is currently showing.
      var activeIndex = $gallery.find('.slp-gallery__thumb.is-active').index();
      if (activeIndex > -1) {
        $media.slick('slickGoTo', activeIndex, true);
      }
    }

    if (window.jQuery.fn.slick) {
      initSlick();
    } else if (window.themeVariables && window.themeVariables.s6Libs && window.themeVariables.s6Libs.slick) {
      // Reuse the theme's on-demand loader (custom.js) if it's available,
      // so slick is only downloaded once and shared across the page.
      var tag = document.createElement('script');
      tag.src = window.themeVariables.s6Libs.slick;
      tag.onload = initSlick;
      document.head.appendChild(tag);
    } else {
      console.error('slick is not loaded and no s6Libs.slick URL was found');
    }
  });

  $(document).on('click', '.slp-gallery-zoom-close', function () {
    $(this).closest('.slp-gallery-zoom-popup-wrap')
      .removeClass('active')
      .attr('open', 'false');
  });

  $(document).on('click', '.slp-g-z-p-m-bg', function () {
    $(this).closest('.slp-gallery-zoom-popup-wrap')
      .removeClass('active')
      .attr('open', 'false');
  });
})();